import {
    ChartConfig,
    ChartContainer,
    ChartLegend,
    ChartLegendContent,
    ChartTooltip,
    ChartTooltipContent
} from "../../../../../components/general/chart.tsx";
import {Bar, CartesianGrid, Cell, ComposedChart, XAxis, YAxis} from "recharts";
import {CashflowPageState} from "./CashflowPageState.ts";
import {formatYAxisTick} from "../../../../../lib/utils.ts";
import {getCashflowAccentColors} from "../../../../../lib/accentPalette";

const CASHFLOW_COLORS = getCashflowAccentColors();

const chartConfig = {
    outflow: {
        label: "uitgaven",
        color: CASHFLOW_COLORS.outflow.base,
    },
    inflow: {
        label: "inkomsten",
        color: CASHFLOW_COLORS.inflow.base,
    },

} satisfies ChartConfig


interface Props {
    data: any,
    className: string
    onBarClick: (data: CashflowPageState) => void
    selectedBar?: CashflowPageState
}

export default function MonthlyInflowOutflowGraph({data, className, onBarClick, selectedBar}: Props) {

    if (!data) return;
    const reversedData = [...data].reverse();

    function handleBarClick(data: any, index, flow: 'inflow' | 'outflow') {
        onBarClick({
                month: data.month,
                flow: flow
            }
        )
    }
    
    return (

        <div
            className={"p-8 rounded-lg bg-white md:grid-cols-3 border-2 border-gray-50 w-full " + (className || " ")}>

            <ChartContainer config={chartConfig} className="h-[100%] w-full">
                <ComposedChart accessibilityLayer data={reversedData}>
                    <CartesianGrid vertical={false}/>
                    <XAxis
                        dataKey="display_date"
                        tickLine={false}
                        tickMargin={10}
                        axisLine={false}
                    />
                    <YAxis
                        tickFormatter={formatYAxisTick}
                        tickLine={false}
                        tickMargin={10}
                        axisLine={false}
                        width={50}
                    />
                    <ChartTooltip content={<ChartTooltipContent/>}/>
                    <ChartLegend content={<ChartLegendContent/>}/>
                    <Bar className="cursor-pointer" dataKey="inflow" radius={4} fill="var(--color-inflow)"
                         onClick={(data: any, i: number) => handleBarClick(data, i, 'inflow')}>
                        {
                            data.slice().reverse().map((entry, index) => {
                                const isSelected =  (index === new Date(selectedBar?.month).getMonth() && selectedBar?.flow === 'inflow')
                                return <Cell key={`cell-${index}`} fill={isSelected ? CASHFLOW_COLORS.inflow.selected : CASHFLOW_COLORS.inflow.base} stroke={CASHFLOW_COLORS.inflow.base} strokeWidth={2}/>
                            })
                        }
                    </Bar>
                    <Bar className="cursor-pointer" dataKey="outflow" fill="var(--color-outflow)" radius={4}
                         onClick={(data: any, i: number) => handleBarClick(data, i, 'outflow')}>
                        {
                            data.slice().reverse().map((entry, index) => {
                                const isSelected =  (index === new Date(selectedBar?.month).getMonth() && selectedBar?.flow === 'outflow')
                                return <Cell key={`cell-${index}`} fill={isSelected ? CASHFLOW_COLORS.outflow.selected : CASHFLOW_COLORS.outflow.base} stroke={CASHFLOW_COLORS.outflow.base} strokeWidth={2}/>
                            })
                        }
                    </Bar>
                </ComposedChart>
            </ChartContainer>
        </div>
    );
}

